<a 
    *ngFor="let site of sites; trackBy: utils.trackByIndex" 
    title="{{site.domain}}" 
    href="{{site?.permalink}}" 
    target="_blank" 
    class="site-{{site.abbreviation}}" 
    [ngClass]="{primary: site.primary}">
        {{site.abbreviation}}
</a>